export default __webpack_public_path__ + "static/apple-app-store-badge-46c4ee2611c43be5658c7cd7126023c6.png";